<template>
  <CButton
    class="py-1 border-1 w-9"
    ghost
    iconPlacement="left"
    size="medium"
    :themeOverrides="{
      border: `1px solid ${themeVars.primary6}`,
    }"
    @click.stop="emit('click')"
  >
    <template #icon>
      <CIcon icon="download" size="16" />
    </template>
  </CButton>
</template>

<script setup lang="ts">
import CIcon from '@lib/components/CIcon/CIcon.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import useThemeVars from '@lib/composables/useThemeVars'

const themeVars = useThemeVars()
const emit = defineEmits<{
  click: []
}>()
</script>
